import angular from 'angular';
import DynamicFiltersDirective from './dynamic-filters.directive';

let DynamicFiltersModule = angular.module('catalog.productsList.dynamicFilter', [])
  .directive('dynamicFilters', DynamicFiltersDirective);

export default DynamicFiltersModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/products-list/dynamic-filters/dynamic-filters.js
 **/